import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';


function Slideshow({ data }) {
    const [slideIndex, setSlideIndex] = useState(1);

    const showDivs = (n) => {
        let x = document.getElementsByClassName("mySlides");
        for (let i = 0; i < x.length; i++) {
            x[i].style.display = "none";
        }
        if (x[slideIndex-1]) {
            x[slideIndex-1].style.display = "block";
        }
        if (n === 1) {
            window.jQuery(x[0]).find("span")[0].innerHTML = n.toString() + " of " + x.length.toString();
        } else {
            window.jQuery(x[slideIndex - 1]).find("span")[0].innerHTML = slideIndex.toString() + " of " + x.length.toString();
        }
    };

    const plusDivs = (n) => {
        let x = document.getElementsByClassName("mySlides");
        let newSlideIndex = slideIndex + n;
        if (newSlideIndex > x.length) {
            setSlideIndex(1);
        } else if (newSlideIndex < 1) {
            setSlideIndex(x.length);
        } else {
            setSlideIndex(newSlideIndex);
        }
    };

    useEffect(() => {
        // Ensure jQuery is loaded before using it
        if (window.jQuery) {
            window.jQuery(document).ready(function() {
                showDivs(slideIndex);
            });
        }
    }, [slideIndex]);

    return (
        <div key={data.documentId} className="slideshow screen-width light-gray-background" style={{display: 'flex', justifyContent: 'center'}}>
            <div className="views-row views-row-3 views-row-odd">

                <article id="node-21" className="node node-slideshow-band node-promoted node-teaser contextual-links-region clearfix" about="/node/21" typeof="sioc:Item foaf:Document">

                    <div className="row background-full-width vertical-align slideshow-div " style={{ maxWidth: "1079px" }}>

                        <div className="container slideshow-container no-padding" style={{ maxWidth: "1079px" }}>
                            <div className="slideshow-title">
                                <p className="section-headline light-blue-text">
                                    Success Stories
                                </p>
                            </div>

                            <div className="container col-sm-12 col-xs-12 no-padding full-height" id={'parent-div-1'} style={{width: '100%'}}>
                                <div className="col-xs-12 slides no-padding" id={'parent-div-2'} style={{width: '100%'}}>

                                    <div className="mySlides" id="firstSlide">
                                        <img alt="slide image" className="center-align slide-image" src={ data.slides[0].image.url } />
                                        <div className="slide-text">
                                            <span className="pull-right" id="slideIndex"></span>
                                            <div className="">
                                                <Markdown>{ data.slides[0].text.replaceAll('\n','  \n')}</Markdown>
                                            </div>
                                        </div>
                                    </div>

                                    {data.slides.filter((_, slideIdx) => slideIdx !== 0).map((slide, slideIdx) => (
                                        <div key={ slideIdx } className="mySlides">
                                            <img alt="slide image" className="center-align slide-image" src={ slide.image.url } />
                                            <div className="slide-text">
                                                <span className="pull-right" id="slideIndex"></span>
                                                <div className="" style={{ fontSize: "16px !important" }}>
                                                    <Markdown>{ slide.text.replaceAll('\n','  \n') }</Markdown>
                                                </div>
                                            </div>
                                        </div>
                                    ))}


                                    <button className=" w3-display-left slideshow-button" onClick={ (e) => plusDivs(-1) } style={{position: 'absolute'}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="37" height="187" viewBox="0 0 37 187">
                                            <image id="Back_arrow" data-name="Back arrow" width="37" height="187" xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAC7BAMAAAAQ3EoDAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAKlBMVEUBIi9EU1pOXGKQlZmJkJNXY2lncXcwQ0xveH0ULzp8hIgjOUN2foMAAADDSUsoAAAADXRSTlPw8/P5+PT18vbx9/H2EPJb4AAAAAFiS0dEDfa0YfUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhBBQSMSDZplTrAAAAW0lEQVRIx2NgGAWjYBSMglEwCigEgphCTCaYYspGmMqMFchWZopFWQKmMjNqKiu2wPTWLJMCDDHOxe4UKdyAReFKLAqtJlBboQ2mGOcqhlEwCkbBKBgFo4DmAAD6wxNAgHkQSQAAAABJRU5ErkJggg=="></image>
                                        </svg>
                                    </button>

                                    <button className="w3-display-right slideshow-button" onClick={ (e) => plusDivs(1) } style={{position: 'absolute', right:'-12px'}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="37" height="187" viewBox="0 0 37 187">
                                            <image id="More_Arrow" data-name="More Arrow" width="37" height="187" xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAC7BAMAAAAQ3EoDAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUBIi9XY2kwQ0w6S1OQlZmJkJNncXdveH0ULzp8hIiDio5OXGJEU1ojOUMAAACopC3bAAAADnRSTlPw9PLy+fj19vH3+PPz8TQ5uQsAAAABYktHRA5vvTBPAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QQUEjEg2aZU6wAAAFxJREFUSMdjYBgFo2AUjIJRMArIBowKmGImQZhibK5YFKZQopAdi0KOKVgUdlJdYZcrptgWNwwhbpcEcpUdwVTGFIKpTJWqyloxlTFcxVQ2CkbBKBgFo2AU0AYAAHdKEh+Hi8HGAAAAAElFTkSuQmCC"></image>
                                        </svg>
                                    </button>

                                </div>


                            </div>

                        </div>

                    </div>

                </article>

            </div>
        </div>
    );
}

export default Slideshow;
